import { render, staticRenderFns } from "./EmployeeSalarySettingsTable.vue?vue&type=template&id=a11223da&"
import script from "./EmployeeSalarySettingsTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalarySettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports